import React from "react";

function Scan() {
  return <h2>Scan</h2>;
}

export default Scan;
